module.exports = __webpack_public_path__ + "img/item2.245ef501.png";